import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import {
  Typography,
  Card,
  CardContent,
  Grid,
  Button,
  FormControl,
  InputLabel,
  Container,
  MenuItem,
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Paper,
  TextField,
  InputAdornment,
  IconButton,
  CircularProgress,
  Backdrop
} from '@material-ui/core';
import { Icon } from '@iconify/react';
import syncFill from '@iconify/icons-eva/sync-fill';
import { makeStyles } from '@material-ui/styles';
import FingerprintIcon from '@material-ui/icons/Fingerprint';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ThumbDownIcon from '@material-ui/icons/ThumbDown';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import moment from 'moment';
import Controls from '../controls/Controls';

import { useConstantsContext } from '../../context/constants_context';
import { useClientContext } from '../../context/client_context';
import {
  baseUrl,
  gender,
  maritalState,
  employers,
  titles,
  employerCodes,
  memberStatuses,
  terminationReasons,
  benefitTypes,
  relationShips,
  suffixes
} from '../../utils/constants';
import DependantSub from './DependantSub';
import Card1 from '../Card1';
import DependantsDocs from '../dependants/DependantsDocs';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    border: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0
    }
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary
  },
  color: {
    backgroundColor: '#f5f5f5'
  },
  newButton: {
    position: 'absolute',
    right: '10px'
  }
}));

export default function DependantsEdit() {
  const classes = useStyles();
  const navigate = useNavigate();
  const { id } = useParams();
  const { towns, suburbs, banks, bankBranches } = useConstantsContext();
  const { clientRefId, currDependant, setClientRefId, setDependant } = useClientContext();
  const [formData, setFormData] = useState(null);
  const [newMember, setNew] = useState(true);
  const [operation, setOperation] = useState('save');
  const [loading, setLoading] = useState(false);
  const [isMain, setMain] = useState(true);
  const [isDisabled, setDisabled] = useState(false);
  const [expanded, setExpanded] = React.useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: '',
    subTitle: '',
    heading: '',
    color: ''
  });

  const PersonalDetailsSchema = Yup.object().shape({
    // firstName: Yup.string()
    //   .min(2, 'First Name is too Short!')
    //   .max(50, 'First Name is too Long!')
    //   .required('First name required'),
    // surname: Yup.string()
    //   .min(2, 'Surname is too Short!')
    //   .max(50, 'Surname is too Long!')
    //   .required('Last name required'),
    // emailAddress: Yup.string().email('Email must be a valid email address'),
    // cellNumber: Yup.number().required('Cell Number is required'),
    // dateOfBirth: Yup.date()
  });

  //   const initialValue = {
  //     firstName: currDependant.firstName,
  //     surname: currDependant.surname,
  //     idNumber: currDependant.idNumber,
  //     dateOfBirth: moment(currDependant.dateOfBirth).format('yyyy-MM-DD'),
  //     membershipStartDate: moment(currDependant.membershipStartDate).format('yyyy-MM-DD'),

  //     gender: currDependant.gender,
  //     addressLine1: currDependant.addressLine1,
  //     addressLine2: currDependant.addressLine2,
  //     addressLine3: currDependant.addressLine3,
  //     provinceLookupKey: currDependant.provinceLookupKey,
  //     cellNumber: currDependant.cellNumber,
  //     emailAddress: currDependant.emailAddress,
  //     maritalStatus: currDependant.maritalStatus,
  //     employerRefId: currDependant.employerRefId,
  //     paypointRefId: currDependant.paypointRefId,
  //     postalCode: currDependant.postalCode,
  //     group_id: currDependant.group_id,
  //     sex_ID: currDependant.sex_ID,
  //     title_id: currDependant.title_id,
  //     age: currDependant.age,
  //     principalSchemeID: currDependant.principalSchemeID,
  //     physical_Town_ID: currDependant.physical_Town_ID,
  //     physical_Suburb_ID: currDependant.physical_Suburb_ID,
  //     bank_ID: currDependant.bank_ID,
  //     acc_No: currDependant.acc_No,
  //     acc_Name: currDependant.acc_Name,
  //     home_Phone: currDependant.home_Phone,
  //     postal_Phone: currDependant.postal_Phone,
  //     physical_Add1: currDependant.physical_Add1,
  //     accName: currDependant.accName
  //   };

  useEffect(() => {
    getDependantById();
    // setFormData(initialValue);
  }, []);

  const formik = useFormik({
    initialValues: currDependant,
    enableReinitialize: true,
    validationSchema: PersonalDetailsSchema,
    onSubmit: (values) => {
      console.log('custingo before that exe 2', values);
      if (operation === 'save') {
        SaveDependant(values);
      } else if (operation === 'terminate') {
        terminateMember(values);
      } else if (operation === 'reinstate') {
        reinstateMember(values);
      }
    }
  });

  currDependant.dateOfBirth = moment(currDependant.dateOfBirth).format('yyyy-MM-DD');
  // setMemberNo(currDependant.memberShipNo);
  currDependant.membershipStartDate = moment(currDependant.membershipStartDate).format(
    'yyyy-MM-DD'
  );
  if (currDependant.termdate)
    currDependant.termdate = moment(currDependant.termdate).format('yyyy-MM-DD');
  const date1 = moment(currDependant.dateOfBirth);
  const date2 = moment();
  const diff = date2.diff(date1, 'years');
  currDependant.age = diff;

  const handleFormUpdate = (e) => {
    SaveDependant(e);
  };

  const SaveDependant = (client) => {
    const jsonClient = [];
    jsonClient.push(client);
    console.log('client stringified now', JSON.stringify(jsonClient[0]));
    fetch(`${baseUrl}/api/client/SaveDependant`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(jsonClient[0])
    })
      .then((res) => res.json())
      .then(
        (result) => {
          setClientRefId(result.refId);
          setDependant(result);
          notifyPopup(`Dependant changes saved successfully!`, 'success');
        },
        (error) => {
          notifyPopup(
            `Error in Saving Dependant Changes, Changes not effected!: ${error}`,
            'error'
          );
        }
      );
  };

  const terminateMember = (value) => {
    console.log('sessionStorage.getIt', value);
    if (sessionStorage.getItem('oldRefId') !== '6') {
      notifyPopup(`Only Supervisor Can Terminate Member...Member not terminated!`, 'error');
      formik.setFieldValue('termdate', '');
      formik.setFieldValue('reasonForTerm', '');
      return;
    }
    setLoading(true);
    const jsonClient = [];
    jsonClient.push(value);
    fetch(
      `${baseUrl}/api/client/setSsbRecordForDelete?terminated_by=${sessionStorage.getItem(
        'oldRefId'
      )}`,
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(jsonClient[0])
      }
    )
      .then((res) => res.json())
      .then(
        (result) => {
          setLoading(false);
          console.log('from terminate', result);
          if (result.replyStatus === 0) {
            notifyPopup(`Member SSB Termination Record Successfully!`, 'success');
            navigate('/dashboard', { replace: true });
          } else {
            notifyPopup(`Error in Terminating Client!: ${result.result.replyMessage}`, 'error');
          }
        },
        (error) => {
          setLoading(false);
          notifyPopup(`Error in Terminating Client..!: ${error}`, 'error');
        }
      );
  };

  const reinstateMember = (value) => {
    setLoading(true);
    const reinstateDate = moment();
    fetch(
      `${baseUrl}/api/client/ReinstateMember?cif_no=${value.cif_number}&reinstation_date=${moment(
        reinstateDate
      ).format('YYYY-MM-DD')}&terminated_by=${sessionStorage.getItem('oldRefId')}&dependants=${
        value.dependents
      }&group_id=${value.group_id}&anniv_date=${moment(reinstateDate).format(
        'YYYY-MM-DD'
      )}&schemeID=${value.principalSchemeID}`,
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      }
    )
      .then((res) => res.json())
      .then(
        (result) => {
          setLoading(false);
          console.log('from reinstate', result);
          if (result.result.replyStatus === 0) {
            notifyPopup(`Member Reinstated Successfully!`, 'success');
            navigate('/dashboard', { replace: true });
          } else {
            notifyPopup(`Error in Reinstating Client!: ${result.result.replyMessage}`, 'error');
          }
        },
        (error) => {
          notifyPopup(`Error in Reinstating Client..!: ${error}`, 'error');
        }
      );
  };

  const getDependantById = async (event) => {
    if (id === -1) {
      return;
    }
    if (id === 0) {
      return;
    }
    setLoading(true);

    await axios(`${baseUrl}/api/client/GetDependantByRefId?refId=${id}`).then(
      (result) => {
        setLoading(false);
        console.log('depend result', result);
        setDependant(result.data);
      },
      (error) => {
        notifyPopup(`Error in Getting Dependant!: ${error}`, 'error');
      }
    );
  };

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  const closePopup = () => {
    setOpenPopup(false);
    navigate('/dashboard', { replace: true });
  };

  const { errors, touched, getFieldProps } = formik;

  return (
    <Container>
      <Card>
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
          onClick={handleLoadingClose}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <CardContent>
          <FormikProvider value={formik}>
            <Form autoComplete="off" noValidate>
              <Grid
                margin={2}
                container
                direction="row"
                justifyContent="space-between"
                alignItems="right"
              >
                <Grid item xs={12} sm={3} marginRight={1}>
                  <Typography component="span" variant="h6" gutterBottom>
                    Update Dependant
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={1} marginRight={3}>
                  <Button
                    type="submit"
                    variant="outlined"
                    disabled={isDisabled}
                    startIcon={<ThumbUpIcon />}
                    onClick={() => setOperation('save')}
                  >
                    Save...
                  </Button>
                </Grid>
              </Grid>
              <Grid container spacing={2} justifyContent="center" alignItems="center">
                <Grid item xs={12} sm={2}>
                  <Controls.SelectJson name="title_id" label="Title" options={titles} />
                </Grid>
                <Grid item xs={12} sm={5}>
                  <Controls.Input name="firstName" label="First Name" />
                </Grid>
                <Grid item xs={12} sm={5}>
                  <Controls.Input name="surname" label="Last Name" />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Controls.Input name="idNumber" label="Id Number" />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Controls.DateTime name="dateOfBirth" label="Date Of Birth" />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Controls.SelectJson name="sex_ID" label="Gender" options={gender} />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Controls.Input name="age" label="Age" />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Controls.SelectJson
                    name="maritalStatus"
                    label="Marital Status"
                    options={maritalState}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Controls.SelectJson
                    name="relationship_ID"
                    label="Relationship to Main"
                    options={relationShips}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Controls.SelectJson name="suffix" label="Suffix" options={suffixes} />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Controls.SelectJson
                    name="memberStatus"
                    label="Member Status"
                    options={memberStatuses}
                  />
                </Grid>
                <Grid item xs={12} sm={3} paddingBottom={2}>
                  <Controls.DateTime name="membershipStartDate" label="Membership Start Date" />
                </Grid>
                <Grid item xs={12} sm={3} paddingBottom={2}>
                  <Controls.SelectJson
                    name="benefitType"
                    label="Source Type"
                    options={benefitTypes}
                  />
                </Grid>
                <Grid item xs={12} sm={3} paddingBottom={2}>
                  <Controls.CheckBox name="beneficiary" label="Nominated" />
                </Grid>
              </Grid>
              <div className={classes.root}>
                <Accordion expanded={expanded === 'panel6'} onChange={handleChange('panel6')}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel3bh-content"
                    id="panel3bh-header"
                    className={classes.color}
                  >
                    <Typography className={classes.heading}>Termination Details</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={3}>
                        <Controls.DateTime name="termdate" label="Terminated Date" />
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <TextField
                          variant="outlined"
                          name="reasonForTerm"
                          id="reasonForTerm"
                          select
                          fullWidth
                          size="small"
                          label="Reason for Termination"
                          value={formik.values.reasonForTerm}
                          onChange={(e) => {
                            formik.setFieldValue('reasonForTerm', e.target.value);
                          }}
                        >
                          <MenuItem key="" value="0">
                            Not Selected
                          </MenuItem>
                          {terminationReasons.map((option) => (
                            <MenuItem key={option.refId} value={option.name}>
                              {option.name}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <Controls.Input name="terminatedBy" label="Approved by" disabled />
                      </Grid>
                      {currDependant.memberStatus === 1 && (
                        <Grid item xs={12} sm={1}>
                          <Button
                            type="submit"
                            variant="outlined"
                            color="error"
                            startIcon={<ThumbDownIcon />}
                            onClick={() => setOperation('terminate')}
                          >
                            Terminate
                          </Button>
                        </Grid>
                      )}
                      {currDependant.memberStatus === 5 && (
                        <Grid item xs={12} sm={1}>
                          <Button
                            type="submit"
                            variant="outlined"
                            color="success"
                            startIcon={<ThumbUpIcon />}
                            onClick={() => setOperation('reinstate')}
                          >
                            Reinstate
                          </Button>
                        </Grid>
                      )}
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              </div>
            </Form>
            <DependantsDocs />
            <Controls.Notification notify={notify} setNotify={setNotify} />
          </FormikProvider>

          <Controls.Popup title="Add Dependant" openPopup={openPopup} setOpenPopup={setOpenPopup}>
            <DependantSub closePopup={closePopup} />
          </Controls.Popup>
          <Controls.ConfirmDialog
            confirmDialog={confirmDialog}
            setConfirmDialog={setConfirmDialog}
          />
        </CardContent>
      </Card>
    </Container>
  );
}
